import moment from "moment";

export const hasChanges = (currentData, originalData) => {
    if (!originalData) return true;
    
    const compareFields = [
      'type', 'title', 'details', 'venue', 'time', 'date',
      'registrationLink', 'socialGroupLink', 'kidsWelcome',
      'isActive', 'isPublished'
    ];
  
    // The form holds the date as YYYY-MM-DD and the server sends a full
    // timestamp, so compare both in the form's format.
    const original = {
      ...originalData,
      date: originalData.date ? moment(originalData.date).format("YYYY-MM-DD") : "",
    };

    // Check if any of the basic fields have changed
    const hasFieldChanges = compareFields.some(field => 
      (currentData[field] ?? "").toString() !== (original[field] ?? "").toString()
    );
  
    // Check if days array has changed (the server calls it recurringDays)
    const hasDaysChanges =
      JSON.stringify(currentData.days || []) !==
      JSON.stringify(originalData.recurringDays || originalData.days || []);
  
    // Check if file has changed
    const hasFileChange = 
      (currentData.file instanceof File) || // New file uploaded
      (currentData.file?.url !== originalData.file?.url); // Different existing file
  
    return hasFieldChanges || hasDaysChanges || hasFileChange;
  };
  